import axios from 'axios';
import logger from '../utils/logger';

//const API_URL = 'http://localhost:5002/api'; // Update this to your actual API URL
const API_URL = 'https://backend-rough-bird-115.fly.dev'

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include the auth token in all requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const registerUser = async (userData) => {
  try {
    const response = await api.post('/api/users/register', userData);
    return response.data;
  } catch (error) {
    logger.error('Error in registerUser:', error);
    throw error;
  }
};

export const loginUser = async (credentials) => {
  try {
    const response = await api.post('/api/users/login', credentials);
    return response.data;
  } catch (error) {
    logger.error('Error in loginUser:', error);
    throw error;
  }
};

export const getProfile = async (userId) => {
  try {
    const response = await api.get(`/api/users/${userId}`);
    return response.data;
  } catch (error) {
    logger.error('Error in getProfile:', error);
    throw error;
  }
};

export const updateProfile = async (userId, updatedData) => {
  try {
    const response = await api.put(`/api/users/${userId}`, updatedData);
    return response.data;
  } catch (error) {
    logger.error('Error in updateProfile:', error);
    throw error;
  }
};

export const createRole = async (userId, roleData) => {
  try {
    const response = await api.post(`/api/users/${userId}/roles`, roleData);
    return response.data;
  } catch (error) {
    logger.error('Error in createRole:', error);
    throw error;
  }
};

export const getRoles = async (userId) => {
  try {
    const response = await api.get(`/api/users/${userId}/roles`);
    return response.data;
  } catch (error) {
    logger.error('Error in getRoles:', error);
    throw error;
  }
};

export const updateRole = async (userId, roleId, roleData) => {
  try {
    const response = await api.put(`/api/users/${userId}/roles/${roleId}`, roleData);
    return response.data;
  } catch (error) {
    logger.error('Error in updateRole:', error);
    throw error;
  }
};

export const deleteRole = async (userId, roleId) => {
  try {
    const response = await api.delete(`/api/users/${userId}/roles/${roleId}`);
    return response.data;
  } catch (error) {
    logger.error('Error in deleteRole:', error);
    throw error;
  }
};

export const getDismissedGuides = async () => {
  try {
    logger.debug('[API] Fetching dismissed guides from backend');
    const response = await api.get('/api/users/dismissed-guides');
    logger.debug('[API] Dismissed guides response:', response.data);
    
    // Ensure we're returning an array
    const guides = response.data.dismissedGuides || [];
    if (!Array.isArray(guides)) {
      logger.error('[API] Backend returned non-array for dismissedGuides:', guides);
      return [];
    }
    
    return guides;
  } catch (error) {
    logger.error('Error in getDismissedGuides:', error);
    throw error;
  }
};

export const dismissGuide = async (guideKey) => {
  try {
    logger.debug(`[API] Dismissing guide: ${guideKey}`);
    const response = await api.post('/api/users/dismiss-guide', { guideKey });
    logger.debug('[API] Dismiss guide response:', response.data);
    
    // Ensure we're returning an array
    const guides = response.data.dismissedGuides || [];
    if (!Array.isArray(guides)) {
      logger.error('[API] Backend returned non-array for dismissedGuides after dismissal:', guides);
      return [];
    }
    
    return guides;
  } catch (error) {
    logger.error('Error in dismissGuide:', error);
    throw error;
  }
};

export default api;
